class ProductCustomerStories extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-product-customer-stories-track]');
    this.originalCards = Array.from(
      this.querySelectorAll('[data-product-customer-story-card]:not([data-product-customer-story-clone])')
    );

    this.querySelector('[data-product-customer-stories-prev]')?.addEventListener('click', () => this.goRelative(-1));
    this.querySelector('[data-product-customer-stories-next]')?.addEventListener('click', () => this.goRelative(1));
  }

  goRelative(direction) {
    if (!this.track || this.originalCards.length === 0) return;

    const currentCard = this.closestSnappedCard;
    const currentIndex = this.originalCards.indexOf(currentCard);
    const targetIndex = (currentIndex + direction + this.originalCards.length) % this.originalCards.length;
    const target = this.originalCards[targetIndex];

    if (target) {
      this.scrollToCard(target);
    }
  }

  scrollToCard(card) {
    if (!this.track || !card) return;

    this.track.scrollTo({
      left: card.offsetLeft,
      behavior: 'smooth',
    });
  }

  get allCards() {
    return this.originalCards;
  }

  get closestSnappedCard() {
    if (!this.track) return this.allCards[0];

    const scrollLeft = this.track.scrollLeft;
    let closestCard = this.allCards[0];
    let closestDistance = Infinity;

    this.allCards.forEach((card) => {
      const distance = Math.abs(scrollLeft - card.offsetLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestCard = card;
      }
    });

    return closestCard;
  }

  originalCards = [];
}

if (!customElements.get('product-customer-stories')) {
  customElements.define('product-customer-stories', ProductCustomerStories);
}
